<template>
  <qx-card title="列表">
    <LogRightDialog ref="logRightDialog" busiCode="100003" />
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
          >
            <section slot-scope="scope">
              <section
                v-if="scope.column.property === 'tenantName'"
                @click="toTenantDetail(scope.row)"
              >
                <span class="primary cur">{{
                  scope.row[scope.column.property]
                }}</span>
              </section>
              <section
                v-else-if="scope.column.property === 'plateNumber'"
                @click="toCarDetail(scope.row)"
              >
                <span class="primary cur">{{
                  scope.row[scope.column.property]
                }}</span>
              </section>
              <section v-else>
                {{ scope.row[scope.column.property] }}
              </section>
            </section>
          </el-table-column>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column prop="control" label="操作" fixed="right">
            <template slot-scope="scope">
              <section>
                <!-- 操作按钮 -->
                <qx-permpisions permpisions="">
                  <span class="primary cur" @click="showLog(scope.row.relId)"
                    >日志</span
                  >
                </qx-permpisions>
                <!-- 操作按钮 end -->
              </section>
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import LogRightDialog from 'components/logRightDialog';
import {
  doQueryVehicleAllHis,
} from 'api/car';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    LogRightDialog,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'plateNumber',
            label: '车牌号码',
          },
          {
            prop: 'vehicleClassName',
            label: '车辆种类',
          },
          {
            prop: 'linkman',
            label: '主驾姓名',
          },
          {
            prop: 'mobilePhone',
            label: '主驾手机',
          },
          {
            prop: 'licenceTypeName',
            label: '牌照类型',
          },
          {
            prop: 'tenantName',
            label: '归属车队',
          },
          {
            prop: 'linkPhone',
            label: '车队手机',
          },
          {
            prop: 'vehicleInfo',
            label: '车辆类型',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: doQueryVehicleAllHis,
    toTenantDetail (item) {
      this.jump({
        label: '车队详情',
        url: `/manage/other/fleet?id=${item.beApplyTenantId}`,
        full: true,
      });
    },
    toCarDetail (item) {
      if (item.licenceType < 3) {
        // 查看普通车辆详情
        const type = 'detail';
        this.jump({
          label: '车辆档案查看',
          url: `/manage/car/archives/record/detail?id=${item.vehicleCode}&vehicleClass=${item.vehicleClass || ''}&verState=9&type=${type}`,
          full: true,
        });
      } else {
        // 查看挂车详情
        this.jump({
          label: `查看挂车-${item.plateNumber}`,
          url: `/manage/car/trailer/archives/detail?id=${item.vehicleCode}&type=${''}`,
          full: true,
        });
      }
    },
    showLog (id) {
      this.$refs.logRightDialog.show(id);
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
